<template>
  <div class="product-info-wrapper">
    <div class="banner">
      <div class="cover cover-wgzxxcx">
        <div class="cover-text">
          <h4>网格中心小程序</h4>
          <p class="info">支撑网格员开展事件上报，任务查询、信息收集等日常工作，加强线上基层治理事件处理，简化工作流程，全面、及时的掌握居民基本信息，切实推进智慧治理。</p>
        </div>
      </div>
    </div>
    <!-- 产品功能 -->
    <div class="product-function">
      <div class="common-title">
        <div class="common-title-content">
          产品功能
        </div>
      </div>
      <div class="product-function-list">
        <div class="item" v-for="(item, index) in funcList" :key="index">
          <img :src="item.imgUrl" />
          <div class="text">{{ item.text }}</div>
        </div>
      </div>
    </div>
    <!-- 产品优势 -->
    <div class="product-advantage product-advantage-blue bg2F61AE">
      <div class="common-title">
        <div class="common-title-content">
          产品优势
        </div>
      </div>
      <div class="content content-blue">
        <div class="circle">
          <div class="badge">
            <img src="@/assets/images/productInfo/wgzxxcx/badge.png" />
          </div>
          <div class="feature feature-one">
            <div class="text">任务分级下减监督</div>
          </div>
          <div class="feature feature-two">
            <div class="text">基层数据精准采集</div>
          </div>
          <div class="feature feature-three">
            <div class="text">业务数据统计分析</div>
          </div>
        </div>
      </div>
    </div>
    <!-- 应用场景 -->
    <div class="product-application-scene">
      <div class="common-title">
        <div class="common-title-content">
          应用场景
        </div>
      </div>
      <div class="product-scene-list">
        <div class="item" v-for="(item, index) in sceneList" :key="index">
          <img :src="item.imgUrl" />
          <div class="text" v-html="item.text"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "wgzxxcx",
  data() {
    return {
      funcList: [
        {
          imgUrl: require("@/assets/images/productInfo/wgzxxcx/ico_sjcj.png"),
          text: "数据采集"
        },
        {
          imgUrl: require("@/assets/images/productInfo/wgzxxcx/ico_sjsb.png"),
          text: "事件上报"
        },
        {
          imgUrl: require("@/assets/images/productInfo/wgzxxcx/ico_sjtj.png"),
          text: "事件统计"
        },
        {
          imgUrl: require("@/assets/images/productInfo/wgzxxcx/ico_mdjftj.png"),
          text: "矛盾处置"
        }
      ],
      sceneList: [
        {
          imgUrl: require("@/assets/images/productInfo/wgzxxcx/xxcj.png"),
          text: "信息采集"
        },
        {
          imgUrl: require("@/assets/images/productInfo/wgzxxcx/sjsb.png"),
          text: "事件上报"
        },
        {
          imgUrl: require("@/assets/images/productInfo/wgzxxcx/mdhj.png"),
          text: "矛盾化解"
        },
        {
          imgUrl: require("@/assets/images/productInfo/wgzxxcx/rwsh.png"),
          text: "任务审核"
        }
      ]
    };
  }
};
</script>
